module.exports = __webpack_public_path__ + "img/Path 8 Copy@3x.ff4acf00.png";